var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSideBarResearchItemIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.95996 9.35156V0.771576H5.72528V2.77769L6.17279 3.2252H8.31779V9.35156H1.95996Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33287 2.74683H6.2959V0.709854L8.33287 2.74683Z",
    fill: "#009A7E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72261 1.94099L7.08655 0.304929C6.89118 0.109565 6.62638 0 6.35015 0H2.23886C1.69258 0 1.25 0.442579 1.25 0.988858V9.01114C1.25 9.55711 1.69258 10 2.23886 10H8.03899C8.58496 10 9.02785 9.55742 9.02785 9.01114V2.67739C9.02785 2.40116 8.91797 2.13635 8.72292 1.94099H8.72261ZM7.86646 2.48171C7.89115 2.5064 7.91307 2.53326 7.93282 2.56165H6.74829C6.59243 2.56165 6.46589 2.43511 6.46589 2.27925V1.09472C6.49428 1.11447 6.52113 1.13638 6.54582 1.16108L7.86646 2.48171ZM7.77572 9.01207H2.50181C2.35583 9.01207 2.23762 8.89386 2.23762 8.74788V1.25181C2.23762 1.10583 2.35583 0.987624 2.50181 0.987624H5.47826V2.52616C5.47826 3.09126 5.93627 3.54927 6.50138 3.54927H8.03991V8.74788C8.03991 8.89386 7.92171 9.01207 7.77572 9.01207Z",
    fill: "#231E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideBarResearchItemIcon);
export default __webpack_public_path__ + "static/media/SideBarResearchItemIcon.8b6444ee5557ec4ae6562306d5393610.svg";
export { ForwardRef as ReactComponent };